import { useEffect } from "react";
import { usePlayer } from "../player/PlayerContext";

// On an artist's page, the HOARD player plays their songs first, then the rest at random.
export const useArtistFocus = (slug) => {
  const { focusOnArtist } = usePlayer();
  useEffect(() => {
    if (!slug) return undefined;
    focusOnArtist(slug);
    return () => focusOnArtist(null);
  }, [slug, focusOnArtist]);
};
